import { DocumentsEnum } from "./documents.enum";

export class UpdateDocumentStatusRequest{
    documentsApprovalId?:number;
    saleOrderId:number;
    documentName:DocumentsEnum;
    status:boolean;
}

